import { useTranslation } from 'react-i18next';
import { PublicCtaButtons } from '../PublicCtaButtons';

export function HomeFinalCta() {
  const { t } = useTranslation();

  return (
    <section className="mx-auto max-w-4xl px-4 sm:px-6 pt-4 pb-24">
      <div className="rounded-3xl border border-violet-200 bg-violet-50 px-6 py-12 text-center sm:py-16 dark:border-violet-900/50 dark:bg-violet-950/30">
        <h2 className="text-2xl font-bold tracking-tight text-zinc-900 sm:text-3xl dark:text-zinc-50">
          {t('home.finalCta.title')}
        </h2>
        <p className="mx-auto mt-3 max-w-xl text-base leading-relaxed text-zinc-600 dark:text-zinc-300">
          {t('home.finalCta.subtitle')}
        </p>
        <div className="mt-6">
          <PublicCtaButtons />
        </div>
      </div>
    </section>
  );
}
